module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_eight@2x-dcd7018b6d59f1f2508da1631e7d7738.webp";